export class Poster {
    posterID: number;
    name: string;
    confirmation: string;
    width: number;
    height: number;
    lastModified: number;
    createDate: number
    previewURL: string;
    thumbPreviewURL: any;
    thumbPreview: any;
    mainPreview: any;
    constructor(contentID?: number, name?: string, confirmation?: string, 
                width?: number, height?: number, lastModified?: number,createDate?: number, 
                previewURL?: string, thumbPreviewURL?: string) {
        this.posterID = contentID;
        this.name = name;
        this.confirmation = confirmation;
        this.width = width;
        this.height = height;
        this.lastModified = lastModified;
        this.createDate = createDate;
        this.previewURL = previewURL;
        this.thumbPreviewURL = thumbPreviewURL;
    }

    getPosterID(): number{
        return this.posterID;
    }
    
    getName(): string{
        return this.name;
    }

    setName(name: string): void{
        this.name = name;
    }

    getConfirmation(): string{
        return this.confirmation;
    }

    setConfirmation(conf: string): void{
        this.confirmation = conf;
    }

    getWidth(): number{
        return this.width;
    }

    setWidth(w: number): void{
        this.width = w;
    }

    getHeight(): number{
        return this.height;
    }

    setHeight(h: number): void{
        this.height = h;
    }

    getLastModified(): number{
        return this.lastModified;
    }

    setLastModified(lm: number): void{
        this.lastModified = lm;
    }

    getCreateDate(): number{
        return this.createDate;
    }
    setCreateDate(cd: number): void{
        this.createDate = cd;
    }

    getPreviewURL(): string{
        return this.previewURL;
    }
    getThumbPreviewURL(): string{
        return this.thumbPreviewURL;
    }

    setThumbPreview(p: any): void{
        this.thumbPreview = p;
    }
    getThumbPreview(): any{
        return this.thumbPreview;
    }

    setMainPreview(p: any): void{
        this.mainPreview = p;
    }
    getMainPreview(): any{
        return this.mainPreview;
    }

    static getPostersFromJSONArray(data: any): Poster[]{
        var posters = [];
        for (var i in data) {
          let cont = new Poster(data[i].contentID, data[i].name, data[i].confirmation, data[i].width, data[i].height,
                                 data[i].lastModified, data[i].createDate, data[i].previewURL, data[i].thumbPreviewURL);
          posters.push(cont);
        }
        return posters;
    }

    static getPosterFromJSON(data: any): Poster{
        let cont = new Poster(data.contentID, data.name, data.confirmation, data.width, data.height,
                               data.lastModified, data.createDate, data.previewURL, data.thumbPreviewURL);
        return cont;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/poster.ts